import { createInstance } from 'localforage';

import { AsyncStorage } from './AsyncStorage';

export function createIndexDBStorage(name: string): AsyncStorage {
  const instance = createInstance({ name });

  return {
    setItem(key: string, value: string): Promise<void> {
      return instance.setItem(key, value).then();
    },
    getItem(key: string): Promise<string | undefined> {
      return instance
        .getItem<string>(key)
        .then((d) => (d === null ? undefined : d));
    },
    removeItem(key: string): Promise<void> {
      return instance.removeItem(key);
    },
  };
}
